import '../../assets/index13.css';var w = Object.defineProperty, A = Object.defineProperties;
var C = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, f = Object.prototype.propertyIsEnumerable;
var u = (t, o, e) => o in t ? w(t, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[o] = e, m = (t, o) => {
  for (var e in o || (o = {}))
    d.call(o, e) && u(t, e, o[e]);
  if (n)
    for (var e of n(o))
      f.call(o, e) && u(t, e, o[e]);
  return t;
}, p = (t, o) => A(t, C(o));
var S = (t, o) => {
  var e = {};
  for (var r in t)
    d.call(t, r) && o.indexOf(r) < 0 && (e[r] = t[r]);
  if (t != null && n)
    for (var r of n(t))
      o.indexOf(r) < 0 && f.call(t, r) && (e[r] = t[r]);
  return e;
};
import { jsx as i } from "react/jsx-runtime";
import l from "react";
import { ProgressIndicator as E } from "../ProgressIndicator/index.js";
import { B as V } from "../../Button-D50dlMrD.js";
const W = "Button-module__root___FeqPS", j = "Button-module__loader___4cAeS", q = "Button-module__label___xdOsD", v = "Button-module__section___WtWx0", D = "Button-module__inner___XSRSZ", h = {
  root: W,
  loader: j,
  label: q,
  section: v,
  inner: D
}, B = (t) => l.isValidElement(t) ? l.Children.count(t.props.children) === 0 ? 1 : l.Children.toArray(t.props.children).reduce((o, e) => o + B(e), 0) : typeof t == "string" || typeof t == "number" ? t.toString().length : 0, k = l.forwardRef((F, z) => {
  var a = F, {
    children: t,
    size: o = "sm",
    variant: e = "accent",
    classNames: r,
    danger: c = !1,
    leftIcon: s,
    rightIcon: _,
    leftSection: g,
    rightSection: b,
    loading: x
  } = a, y = S(a, [
    "children",
    "size",
    "variant",
    "classNames",
    "danger",
    "leftIcon",
    "rightIcon",
    "leftSection",
    "rightSection",
    "loading"
  ]);
  const P = s ? /* @__PURE__ */ i(s, { size: 14 }) : g, R = _ ? /* @__PURE__ */ i(_, { size: 14 }) : b;
  return /* @__PURE__ */ i(
    V,
    p(m({
      classNames: r != null ? r : h
    }, y), {
      ref: z,
      mod: {
        "data-icon-only": B(t) === 1,
        size: o,
        "data-design-variant": e,
        "data-dangerous": c
      },
      leftSection: P,
      rightSection: R,
      loading: x,
      loaderProps: {
        children: /* @__PURE__ */ i(
          E,
          {
            className: h.loader,
            size: 16,
            color: c ? "red" : e === "accent" ? "white" : "violet"
          }
        )
      },
      children: t
    })
  );
});
export {
  k as Button
};
